/**
 * Utilidad para Google Analytics 4 (gtag)
 * Requiere el script de GA4 en index.html
 */
const GA_ID = "G-PGZJVLKC9W";

export function gaPageView(path) {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "page_view", { page_path: path });
  }
}

export function gaEvent(eventName, params = {}) {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", eventName, params);
  }
}

/**
 * Asocia los eventos de GA4 a un usuario (UUID de Supabase).
 * Permite cruzar datos de GA con auth.users en Supabase.
 */
export function gaSetUserId(userId) {
  if (typeof window !== "undefined" && window.gtag && userId) {
    window.gtag("config", GA_ID, { user_id: userId });
  }
}

/**
 * Limpia el user_id al cerrar sesión.
 */
export function gaClearUserId() {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("config", GA_ID, { user_id: "" });
  }
}
